import { render } from "./SFormElementBodyText.vue?vue&type=template&id=44a52821"
import script from "./SFormElementBodyText.vue?vue&type=script&lang=js"
export * from "./SFormElementBodyText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__